module.exports = __webpack_public_path__ + "img/aiot_block2.62bac64f.png";